import extendSchema from "./helpers/extendSchema"
import getMutationSchema from "./helpers/getMutationSchema"


const getFormSchema = operation => {
  const operationSchema = getMutationSchema(operation)

  return inputs => extendSchema(operationSchema, inputs)
}

export default getFormSchema
